const doc = [({"da":({"js":({"admin":({"contact_associates":({"create_card":({"choose_contact":"Vælg kontakt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;